import * as React from 'react';
import { ResponsiveStyleValue } from '../../theming';
import { PriceBlockSize, PriceBlockAlign } from './PriceBlock.types';

interface PriceBlockContextValues {
    size?: PriceBlockSize;
    align?: ResponsiveStyleValue<PriceBlockAlign>;
}

export const PriceBlockContext = React.createContext<PriceBlockContextValues>({});
